/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Open_NoteInputs */

const en_mk_desktop_open_note = /** @type {(inputs: Mk_Desktop_Open_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep Desktop open and your computer awake during local work. You can also connect through the CLI without Desktop.`)
};

const id_mk_desktop_open_note = /** @type {(inputs: Mk_Desktop_Open_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan Desktop terbuka dan komputer menyala selama pekerjaan lokal berjalan. Kamu juga bisa menghubungkan komputer melalui CLI tanpa Desktop.`)
};

/**
* | output |
* | --- |
* | "Keep Desktop open and your computer awake during local work. You can also connect through the CLI without Desktop." |
*
* @param {Mk_Desktop_Open_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_open_note = /** @type {((inputs?: Mk_Desktop_Open_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Open_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_open_note(inputs)
	return en_mk_desktop_open_note(inputs)
});